import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "splide__arrows" }
const _hoisted_2 = { class: "splide__arrow splide__arrow--prev center-y absolute left-12 z-10 rounded-full bg-white p-18 shadow-md" }
const _hoisted_3 = { class: "splide__arrow splide__arrow--next center-y absolute right-12 z-10 rounded-full bg-white p-18 shadow-md" }
const _hoisted_4 = {
  key: 1,
  class: "flex gap-x-20"
}
const _hoisted_5 = { class: "flex flex-col gap-y-16" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "splide__arrows" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_video = _resolveComponent("v-video")
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide_track = _resolveComponent("splide-track")
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_splide = _resolveComponent("splide")

  return ($data.isMobile)
    ? (_openBlock(), _createBlock(_component_splide, {
        key: 0,
        ref: "mainSlider",
        "has-track": false,
        class: "relative bg-black-100",
        options: {
      type: 'loop',
      arrows: $props.media.length > 1 && $props.showArrowsMobile,
      pagination: true,
      mediaQuery: 'min',
      classes: {
        page: 'splide__pagination__page w-6 h-6 mobile-xl:w-8 mobile-xl:h-8 rounded-full bg-black-900',
      },
      breakpoints: {768: {destroy: true}},
    }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_splide_track, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mediaArray, (mobileMedia, i) => {
                return (_openBlock(), _createBlock(_component_splide_slide, {
                  key: mobileMedia.id
                }, {
                  default: _withCtx(() => [
                    (mobileMedia.media_type === 'image')
                      ? (_openBlock(), _createBlock(_component_v_image, {
                          key: 0,
                          lazyloaded: i > 1,
                          source: mobileMedia.src,
                          alt: mobileMedia.alt,
                          class: "aspect-product-gallery w-full object-cover object-top"
                        }, null, 8, ["lazyloaded", "source", "alt"]))
                      : (mobileMedia.media_type === 'video')
                        ? (_openBlock(), _createBlock(_component_v_video, {
                            key: 1,
                            autoplay: "",
                            source: mobileMedia.sources[0].url,
                            "source-mobile": mobileMedia.sources[0].url,
                            class: "aspect-product-gallery w-full object-cover object-top"
                          }, null, 8, ["source", "source-mobile"]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", _hoisted_2, [
              _createVNode(_component_v_icon, {
                icon: "arrow-left",
                width: 12,
                height: 12
              })
            ]),
            _createElementVNode("button", _hoisted_3, [
              _createVNode(_component_v_icon, {
                icon: "arrow-left",
                width: 12,
                height: 12,
                flipped: ""
              })
            ])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-full w-full laptop:hidden" }, [
            _createElementVNode("ul", { class: "splide__pagination center-x absolute bottom-20 z-10 gap-8" })
          ], -1)),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3,
        __: [2]
      }, 8, ["options"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mediaArray, (thumbnailMedia, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: thumbnailMedia.id,
              type: "button",
              class: _normalizeClass(["aspect-product-gallery-thumbnail max-h-[6.375rem] w-fit border", $data.activeImageIndex === index ? ' ' : 'border-transparent']),
              onClick: $event => ($options.handleThumbnailClick(index))
            }, [
              (thumbnailMedia.media_type === 'image')
                ? (_openBlock(), _createBlock(_component_v_image, {
                    key: 0,
                    source: thumbnailMedia.src,
                    alt: thumbnailMedia.alt,
                    class: "h-full w-full object-cover object-top"
                  }, null, 8, ["source", "alt"]))
                : (thumbnailMedia.media_type === 'video')
                  ? (_openBlock(), _createBlock(_component_v_video, {
                      key: 1,
                      autoplay: "",
                      source: thumbnailMedia.sources[0].url,
                      "source-mobile": thumbnailMedia.sources[0].url,
                      class: "h-full w-full object-cover object-top"
                    }, null, 8, ["source", "source-mobile"]))
                  : _createCommentVNode("", true)
            ], 10, _hoisted_6))
          }), 128))
        ]),
        _createVNode(_component_splide, {
          ref: "mainSlider",
          "has-track": false,
          class: "relative aspect-product-gallery-desktop h-full flex-1 bg-black-100",
          options: {
        type: 'loop',
        arrows: $props.media.length > 1 && $props.showArrowsDesktop,
        pagination: false,
        drag: false,
      }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_splide_track, { class: "h-full" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mediaArray, (desktopMedia, i) => {
                  return (_openBlock(), _createBlock(_component_splide_slide, {
                    key: desktopMedia.id
                  }, {
                    default: _withCtx(() => [
                      (desktopMedia.media_type === 'image')
                        ? (_openBlock(), _createBlock(_component_v_image, {
                            key: desktopMedia.id,
                            lazyloaded: i > 1,
                            source: desktopMedia.src,
                            alt: desktopMedia.alt,
                            class: "h-full w-full object-cover object-top"
                          }, null, 8, ["lazyloaded", "source", "alt"]))
                        : (desktopMedia.media_type === 'video')
                          ? (_openBlock(), _createBlock(_component_v_video, {
                              key: desktopMedia.id,
                              autoplay: "",
                              source: desktopMedia.sources[0].url,
                              "source-mobile": desktopMedia.sources[0].url,
                              class: "h-full w-full object-cover object-top"
                            }, null, 8, ["source", "source-mobile"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "splide__arrow splide__arrow--prev center-y absolute left-12 z-10 rounded-full bg-white p-18 shadow-md",
                onClick: _cache[0] || (_cache[0] = $event => ($options.handleArrowsClick($data.activeImageIndex - 1)))
              }, [
                _createVNode(_component_v_icon, {
                  icon: "arrow-left",
                  width: 12,
                  height: 12
                })
              ]),
              _createElementVNode("button", {
                class: "splide__arrow splide__arrow--next center-y absolute right-12 z-10 rounded-full bg-white p-18 shadow-md",
                onClick: _cache[1] || (_cache[1] = $event => ($options.handleArrowsClick($data.activeImageIndex + 1)))
              }, [
                _createVNode(_component_v_icon, {
                  icon: "arrow-left",
                  width: 12,
                  height: 12,
                  flipped: ""
                })
              ])
            ]),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["options"])
      ]))
}